import {Images} from "@assets";
import React, {useState, useRef} from "react";

interface IProps {
  max?: number;
  initialValue?: number;
  onChange?: (value: number) => void;
  width?: number;
}

const StarRating = ({
  max = 5,
  initialValue = 0,
  onChange,
  width = 200,
}: IProps) => {
  const [rating, setRating] = useState(initialValue);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!containerRef.current) {
      return;
    }
    const {left, width} = containerRef.current.getBoundingClientRect();
    const clickX = e.clientX - left;
    const percent = clickX / width;

    let newRating = percent * max;
    newRating = Math.round(newRating * 2) / 2; // 0.5 단위
    newRating = Math.max(0.5, Math.min(max, newRating));

    setRating(newRating);
    onChange?.(newRating);
  };

  const filledWidthPercent = (rating / max) * 100;

  return (
    <div
      ref={containerRef}
      onClick={handleClick}
      style={{
        position: "relative",
        width: `${width}px`,
        cursor: onChange ? "pointer" : "auto",
        userSelect: "none",
      }}>
      <img
        src={Images.star}
        alt="empty stars"
        style={{width: "100%", display: "block"}}
      />
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: `${filledWidthPercent}%`,
          overflow: "hidden",
        }}>
        <img
          src={Images.starFill}
          alt="filled stars"
          style={{width: `${width}px`, display: "block", objectFit: "contain"}}
        />
      </div>
    </div>
  );
};

export default StarRating;
